import { mockFormOverrideAddressFieldset } from '@domgen/dgx-fe-forms/address';
import { mockFormField, mockFormFieldset } from '@domgen/dgx-fe-forms/layout';
import { CmsApplianceDetailsSteppedForm } from '../../models/appliance-details-stepped/cms-appliance-details-stepped-form.interface';

export const mockCmsApplianceDetailsSteppedForm: CmsApplianceDetailsSteppedForm =
  {
    brandCodeField: {
      fieldLabel: 'What brand is your appliance?',
      fieldRequired: true,
    },
    applianceCategoryCodeField: {
      fieldLabel: 'What appliance are you registering?',
      fieldRequired: true,
    },
    applianceCodeField: {
      fieldLabel: 'Can you tell us what type of appliance it is?',
      fieldRequired: true,
    },
    registrationCodeField: {
      fieldLabel: 'Enter your registration code',
      fieldRequired: true,
    },
    modelAndSerialNumberFieldset: {
      ...mockFormFieldset,
      modelNumberField: {
        fieldLabel: 'Model number',
        fieldRequired: true,
      },
      serialNumberField: {
        fieldLabel: 'Serial number',
        fieldRequired: true,
      },
    },
    purchasePriceField: {
      fieldLabel: 'How much did you pay for your appliance?',
      fieldRequired: true,
    },
    purchaseDateField: {
      fieldLabel: 'Purchase date of your appliance',
      fieldRequired: true,
    },
    personalDetailsFieldSet: {
      ...mockFormFieldset,
      addressFieldset: mockFormOverrideAddressFieldset,
      firstNameField: mockFormField,
      lastNameField: mockFormField,
      telephoneNumberField: mockFormField,
      emailAddressField: mockFormField,
      privacyPolicyField: mockFormField,
    },
  };
